import { useSyncExternalStore } from "react";
function o(t) {
  return useSyncExternalStore(t.subscribe, t.getSnapshot, t.getSnapshot);
}
export {
  o as useStore
};
